module.exports = __webpack_public_path__ + "img/scene5-8.6cd6cd60.png";